import React from 'react';
import { Link } from 'react-router-dom';

const Home = () => {
  return (
    <div>
      {/* Hero Section */}
      <div className="bg-cover bg-center h-screen flex items-center justify-center" style={{ backgroundImage: 'url(https://via.placeholder.com/1920x1080?text=Ekul+Consulting+Banner)' }}>
        <div className="text-white text-center">
          {/* Logo */}
          <img
            src="/logo.png"
            alt="Ekul Consulting Logo"
            className="w-20 h-20 mx-auto mb-4 rounded-full"
          />

          <h1 className="text-4xl font-bold mb-4">Your Trusted Recruitment Partner</h1>
          <p className="text-xl mb-6">Connecting Skilled Professionals with Opportunities Across Healthcare, Hospitality, Maritime, Security, and More.</p>
          <Link to="/jobs" className="bg-cyan text-white px-4 py-2 rounded hover:bg-blue-700">Explore Jobs</Link>
        </div>
      </div>

      {/* Our Services */}
      <div className="container mx-auto p-8">
        <h2 className="text-3xl font-bold text-center text-royal-blue mb-8">Our Services</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div className="bg-light-green p-4 rounded-lg shadow-md text-center">
            <img src="https://via.placeholder.com/300x200?text=Healthcare" alt="Healthcare" className="w-full h-32 object-cover mb-2" />
            <h3 className="text-xl font-bold text-royal-blue mb-2">Healthcare Recruitment</h3>
            <p className="text-gray-700">Connect skilled healthcare professionals with top institutions.</p>
          </div>
          {/* Repeat for other services */}
        </div>
      </div>
    </div>
  );
};

export default Home;